<template>
    <nav class="breadcrumb" aria-label="Breadcrumb">
        <ol class="breadcrumb__list">
            <li class="breadcrumb__item">
                <a href="">
                    <span class="screen-reader">Terug</span>
                    <svg-icon
                        :icon="IconBack"
                        :size="IconSize.md"
                        :color="Color.brandGreen"
                    />
                </a>
            </li>

            <li
                v-for="(part, index) in breadcrumb"
                :key="index"
                class="breadcrumb__item"
            >
                <router-link
                    v-if="part.route"
                    :to="part.route"
                >
                    {{ part.title }}
                </router-link>

                <a
                    v-else-if="part.href"
                >{{ part.title }}</a>

                <span
                    v-else
                >{{ part.title }}</span>
            </li>
        </ol>
    </nav>
</template>

<script setup lang="ts">
    import { SvgIcon, IconSize, Color } from '@keyvue/one-ui';
    import IconBack from '@keyvue/one-material-icons/icons/navigate_before.svg?component';
    import useBreadcrumb from '@composables/useBreadcrumb';

    const { breadcrumb } = useBreadcrumb();
</script>

<style scoped lang="scss">
.breadcrumb {
    width: 100%;
    padding-bottom: size(lg);

    &__list {
        font-weight: bold;
        display: flex;
        align-items: center;
    }

    &__item {
        color: color(gray-400);
        display: flex;
        align-items: center;

        a {
            color: inherit;
            text-decoration: none;
            display: flex;

            // not sure why this affects the svg-icon, but it needed to be thicker
            stroke: color(brand-green);
            stroke-width: 2px;
        }

        &:nth-child(n+3):before {
            content: '/';
            color: color(gray-400);
            font-size: size(md);
            margin: 0 size(xs);
        }

        &:last-child {
            color: color(brand-black);
        }
    }
}
</style>
